/**
 * 控制台定位搜尋：社區／門牌只飛到地圖，不產生分時圈。
 */
import { SovereignCabinet } from '../../core/cabinet-base.js';
import { autocompleteSuggestionView } from '../../shared/autocomplete-suggestion-label.js';

class MapLocateCabinet extends SovereignCabinet {
  constructor() {
    super();
    this.map = null;
    this._marker = null;
    this._debounce = null;
    this.loadAssets('/js/cabinets/map-locate');
  }

  onMount() {
    this.bus.on('MAP_READY', () => {
      this.map = window.appCore?.getMap?.() || window.appCore?.map || null;
    });
    this.map = window.appCore?.getMap?.() || window.appCore?.map || null;
    this.initSearch();
  }

  onUnmount() {
    if (this._debounce) clearTimeout(this._debounce);
    this.clearMarker();
  }

  setStatus(text) {
    const el = this.shadowRoot?.getElementById('mapLocateStatus');
    if (el) el.textContent = text || '';
  }

  clearMarker() {
    if (this._marker && this.map) {
      try {
        this.map.removeLayer(this._marker);
      } catch {
        /* ignore */
      }
    }
    this._marker = null;
  }

  ensureMap() {
    if (this.map) return this.map;
    this.map = window.appCore?.getMap?.() || window.appCore?.map || null;
    return this.map;
  }

  flyTo(lat, lng, label) {
    const map = this.ensureMap();
    if (!map || !Number.isFinite(lat) || !Number.isFinite(lng)) {
      this.setStatus('❌ 地圖未就緒或無座標');
      return;
    }
    this.clearMarker();
    map.flyTo([lat, lng], 16, { duration: 1.1 });
    if (typeof L !== 'undefined') {
      this._marker = L.circleMarker([lat, lng], {
        radius: 7,
        color: '#fbbf24',
        weight: 2,
        fillColor: '#f59e0b',
        fillOpacity: 0.85
      }).addTo(map);
      if (label) this._marker.bindPopup(label).openPopup();
    }
    this.setStatus(`📍 已定位：${label || `${lat.toFixed(5)}, ${lng.toFixed(5)}`}`);
  }

  initSearch() {
    const input = this.shadowRoot.getElementById('mapLocateSearch');
    const box = this.shadowRoot.getElementById('mapLocateSuggestions');
    if (!input || !box) return;

    input.addEventListener('input', () => {
      const val = input.value.trim();
      if (val.length < 2) {
        box.innerHTML = '';
        box.hidden = true;
        this.setStatus('');
        return;
      }
      clearTimeout(this._debounce);
      this._debounce = setTimeout(() => this.runSearch(val, box, input), 280);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        box.innerHTML = '';
        box.hidden = true;
      }
    });
  }

  async runSearch(val, box, input) {
    this.setStatus(`🔍 搜尋「${val}」…`);
    try {
      const res = await fetch(`/api/autocomplete?q=${encodeURIComponent(val)}&limit=12`, {
        credentials: 'include'
      });
      if (res.status === 401) {
        box.innerHTML = '';
        box.hidden = true;
        this.setStatus('❌ 請先登入後再搜尋');
        return;
      }
      if (!res.ok) {
        box.innerHTML = '';
        box.hidden = true;
        this.setStatus(`❌ 搜尋失敗 HTTP ${res.status}`);
        return;
      }
      const data = await res.json();
      const list = Array.isArray(data) ? data : [];
      box.innerHTML = '';
      if (!list.length) {
        const hint = document.createElement('div');
        hint.className = 'suggestion-item';
        const meta = document.createElement('div');
        meta.className = 'suggestion-meta';
        meta.textContent = '找不到社區或曾調閱門牌';
        hint.appendChild(meta);
        box.appendChild(hint);
        box.hidden = false;
        this.setStatus(`⚠️ 「${val}」無結果`);
        return;
      }
      list.forEach((item) => {
        const div = document.createElement('div');
        div.className = 'suggestion-item';
        const view = autocompleteSuggestionView(item);
        const label = view.label;
        const main = document.createElement('div');
        main.className = 'suggestion-main';
        main.textContent = view.main;
        const meta = document.createElement('div');
        meta.className = 'suggestion-meta';
        meta.textContent = view.meta;
        div.appendChild(main);
        div.appendChild(meta);
        div.onclick = () => {
          input.value = label;
          box.innerHTML = '';
          box.hidden = true;
          const lat = Number(item.lat);
          const lng = Number(item.lng != null ? item.lng : item.lon);
          this.flyTo(lat, lng, label);
        };
        box.appendChild(div);
      });
      box.hidden = false;
      this.setStatus(`🔍 找到 ${list.length} 筆，點選即可定位`);
    } catch (err) {
      box.innerHTML = '';
      box.hidden = true;
      this.setStatus(`❌ ${err.message || '搜尋失敗'}`);
    }
  }
}

customElements.define('map-locate-cabinet', MapLocateCabinet);

function dock() {
  if (!window.appCore) return;
  const container = document.getElementById('socket-map-locate');
  if (!container) return;
  const instance = document.createElement('map-locate-cabinet');
  container.innerHTML = '';
  container.appendChild(instance);
  window.appCore.registerCabinet('mapLocate', instance);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dock);
} else {
  dock();
}
